export const DEFAULT_CONTENT = {
  hero_eyebrow: "Ingleburn · South-West Sydney · NSW",
  hero_heading: "Glass & aluminium work, measured, made & installed — without the runaround.",
  hero_subtitle:
    "From emergency glass replacement to custom shower screens, shopfronts and aluminium windows — quality workmanship across South-West Sydney.",
  about_heading: "A local glazier you can actually get on the phone.",
  about_text:
    "ASAP Glass & Aluminium is a locally owned business based in Ingleburn, servicing homes and businesses across South-West Sydney. We handle everything from urgent glass replacements to full shopfront fit-outs — with honest advice, tidy workmanship and no surprises on the invoice.",
  contact_heading: "Tell us what you need — we'll get back to you fast.",
  services: [
    { title: "Glass Replacement", desc: "Fast replacement of broken or damaged glass in homes and businesses — windows, doors, panels and more." },
    { title: "Aluminium Windows & Doors", desc: "Supply and installation of durable, modern aluminium frames built to last." },
    { title: "Shower Screens", desc: "Framed, semi-frameless and frameless shower screens, custom measured for your bathroom." },
    { title: "Shopfronts", desc: "Commercial shopfront glazing and aluminium framing that makes your business stand out." },
    { title: "Mirrors", desc: "Custom-cut mirrors for bathrooms, gyms, wardrobes and feature walls." },
    { title: "Splashbacks", desc: "Glass splashbacks for kitchens and laundries — clean lines, easy to clean." },
  ],
};

export const mergeContent = (remote) => ({
  ...DEFAULT_CONTENT,
  ...(remote || {}),
  services: DEFAULT_CONTENT.services.map((d, i) => ({ ...d, ...(remote?.services?.[i] || {}) })),
});
